import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class TtsApiKeys extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.FetchDataAjax()
                this.dialogClose();
                this.setState({
                    isChecked: true

                })
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.FetchDataAjax()
                this.dialogClose();
                this.setState({
                    isChecked: true,
                    disabled: false
                })
            }
        }];
        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteRow(this.state.propsId)
                this.setState({
                    disabled: false, isChecked: true, showTable: true
                })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    isChecked: true,
                    disabled: false,
                    showTable: true

                });
            }
        }];
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.FetchDataAjax()
                this.setState({ isChecked: true, disabled: false, showTable: true })

            }
        }];
        this.state = {
            data: [{
                id: '',
                apiType: '',
                key: '',
                secret: '',
                label: '',
                enabled: ''
            }],
            editedapiType: '-1',
            pageNum: null,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            contentEditable: "false",
            showStore: false,
            hideDeletePopup: false,
            deleteRow: false,
            isChecked: false,
            showTable: false,
            deactivateCheck: false,
        }
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.apitypeVar = [];
    }
    componentDidMount() {
        setTimeout(() => {
            this.getProjectVoiceSetting();
            this.loadData();
            this.loadToggleData();
        }, 300);
        var Apikeysontroller = this;
        document.addEventListener("projectChanged", function (event) {
            Apikeysontroller.projectId = event.projectId;
            Apikeysontroller.getProjectVoiceSetting(event.projectId);
            Apikeysontroller.state.disabled = false;
            Apikeysontroller.loadData(event.projectId);
            Apikeysontroller.loadToggleData(event.projectId);

        });
    }
    addRow = (data) => {
        var apiController = this;
        if (apiController.state.pageNum != 0) {
            apiController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            apiType: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });
    }

    notifyDisabledVoice() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please enable project voice settings</b>, {
            position: "top-center"
        });
    }

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key Added Successfully</b>, {
            position: "top-center",

        });
    }
    NotifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key updated Successfully</b>, {
            position: "top-center",

        });
    }

    addCell = (props, e) => {
        var apiController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            this.notifyMsgFieldEmpty();
        } else {
            $.ajax({
                url: "/api/api-key",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "TTS_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        apiController.NotifyAdd();
                        apiController.loadData();
                        apiController.state.disabled = false;
                    } else {
                        apiController.NotifyFailToAdd(res.result);
                        apiController.state.disabled = false;
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }
    updateCell = (props, e) => {
        var apiController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            this.notifyMsgFieldEmpty();
        } else {
            $.ajax({
                url: "/api/api-key-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    id: props.original.id,
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "TTS_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        apiController.NotifyUpdate();
                        apiController.loadData();
                        apiController.state.editedapiType = '-1';
                        apiController.state.disabled = false;
                    } else {
                        apiController.NotifyFailToAdd(res.result);
                        apiController.state.disabled = false;
                        apiController.state.editedapiType = '-1';
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }

    NotifyFailToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    NotifyFailToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    NotifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });
    }
    NotifyFailedLoad(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
        this.loadData();
    }

    activateApiKeyAjax = () => {
        var fetchDataContoller = this;

        $.ajax({
            url: "/api/tts-enable",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    fetchDataContoller.setState({
                        isChecked: true, showTable: true
                    })
                    fetchDataContoller.loadToggleData();
                    fetchDataContoller.NotifyActivatedSuccess();
                } else {
                    fetchDataContoller.state.showTable = false;
                    fetchDataContoller.setState(fetchDataContoller.state);
                    fetchDataContoller.NotifyFailedActivate();
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }


    deactivateAPIKeyAjax = () => {
        var fetchDataContoller = this;

        $.ajax({
            url: "/api/tts-disable",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    fetchDataContoller.setState({
                        isChecked: false, showTable: false
                    })
                    fetchDataContoller.state.disabled = true;
                    fetchDataContoller.loadToggleData();
                    fetchDataContoller.NotifyDeActivatedSuccess();

                } else {
                    fetchDataContoller.state.showTable = false;
                    fetchDataContoller.setState(fetchDataContoller.state);
                    fetchDataContoller.NotifyFailedActivate();
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }
    NotifyDeActivatedSuccess() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;API key de-activated successfully</b>, {
            position: "top-center"
        });
    }
    NotifyActivatedSuccess() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;API key activated successfully</b>, {
            position: "top-center"
        });
    }

    NotifyFailedActivate() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Failed to activate API key</b>, {
            position: "top-center"
        });
    }

    getProjectVoiceSetting = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var voiceAgentComponent = this;
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null && res.result.enabled == false) {
                        voiceAgentComponent.notifyDisabledVoice();
                        setTimeout(() => {
                            window.location.href = window.origin + "/platform/projectmgmt/voice";
                        }, 1000);
                    } else if (res.result == null) {
                        voiceAgentComponent.notifyDisabledVoice();
                        setTimeout(() => {
                            window.location.href = window.origin + "/platform/projectmgmt/voice";
                        }, 1000);
                    }
                } else {
                    voiceAgentComponent.notifyDisabledVoice();
                    setTimeout(() => {
                        window.location.href = window.origin + "/platform/projectmgmt/voice";
                    }, 1000);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    loadToggleData = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var apiController = this;
        var apis = [];
        $.ajax({
            url: "/api/tts-status",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.result === true) {
                    apiController.setState({
                        isChecked: true,
                        showTable: true
                    })
                }
                else if (res.result === false) {
                    apiController.setState({
                        isChecked: false,
                        showTable: false
                    })
                }

            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    loadData = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var apiController = this;
        var apis = [];
        $.ajax({
            url: "/api/api-key/api-type",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                apiType: "TTS_API"
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.success === true) {
                    var apiData = res.result;
                    for (var i = 0; i < apiData.length; i++) {
                        if (apiData[i].apiType == "TTS_API") {
                            apis.push(apiData[i]);
                        }
                        // if (apiData.length == 0 && apiController.state.deactivateCheck == true) {
                        //     apiController.setState({
                        //         isChecked: false,
                        //         showTable: false
                        //     })

                        // }

                        // else if ((apiData[0]["id"] != "" ||
                        //     apiData[0]["id"] != null )&& apiController.state.deactivateCheck==false) {

                        //     apiController.setState({
                        //         isChecked: true,
                        //         showTable: true
                        //     })
                        // }
                        apiController.loadToggleData();
                    }
                    apiController.setState({
                        data: apiData,
                        disabled: false,
                    })
                }
                else {
                    apiController.NotifyFailToLoadData(res.result)
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deleteRow = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteRowViewController.splice(id, 1);
            deleteApiViewController.loadData();
            deleteApiViewController.NotifyMsgDeleteSuccess();
            deleteApiViewController.state.disabled = false;
        }
        $.ajax({
            url: "/api/api-key/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteApiViewController.loadData();
                    deleteApiViewController.NotifyMsgDeleteSuccess();
                    deleteApiViewController.state.disabled = false;

                } else {
                    deleteApiViewController.NotifyFailToDelete(res.result);
                    deleteApiViewController.state.disabled = false;
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }
    NotifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;API key Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    NotifyAutoGenerate = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;API key and secret will be generate automatically</b>, {
            position: "top-center"
        });
    }
    NotifyFailToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {

        this.state.editedapiType = id;
        var stateObj = this.state;
        this.setState(stateObj);

    }
    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedapiType = id;
        this.loadData()
        this.setState({ disabled: false })

    }
    checkHandle = () => {
        if (document.getElementById("activate").checked == true) {
            this.activateAPIKeyaHandleChange();
        } else {
            this.deactivateAPIKeyaHandleChange();
        }

    }
    activateAPIKeyaHandleChange = (e) => {

        this.setState({

            isChecked: true,
            showTable: true

        })

        this.activateApiKeyAjax();
    }

    deactivateAPIKeyaHandleChange = (e) => {

        this.setState({

            isChecked: false,
            showTable: false

        })
        this.deactivateAPIKeyAjax();

    }
    render() {
        this.columns = [
            {
                Header: 'Id',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Label</b>,
                accessor: 'label',
                sortable: false,
                Cell: props => (<div className="input"
                    Align="left"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == undefined || props.original.id == this.state.editedapiType) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedapiType) ? "plaintext-only" : false}
                    type="text" id={"label" + props.index}>{props.original.label}</div>
                )
            },
            {
                Header: <b>Key</b>,
                accessor: 'key',
                sortable: false,
                Cell: props => (<div onClick={(e) => { ((props.original.id == undefined) || props.original.id == this.state.editedapiType) ? this.NotifyAutoGenerate() : "" }}
                    Align="left" className="textarea"
                    contentEditable={false}
                    type="text" id={"key" + props.index}>{props.original.key}</div>
                )
            },
            {
                Header: <b>Secret</b>,
                accessor: 'secret',
                sortable: false,
                Cell: props => (<div onClick={(e) => { ((props.original.id == undefined) || props.original.id == this.state.editedapiType) ? this.NotifyAutoGenerate() : "" }}
                    Align="left" className="textarea"
                    contentEditable={false}
                    type="text" id={"secret" + props.index}
                >{props.original.secret}</div>)
            },
            {
                Header: <b>Enable API Key</b>,
                accessor: 'enableApiKey',
                sortable: false,
                width: 110,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox" id={"enableApiKey" + props.index}
                                    defaultChecked={props.original.enabled}
                                    disabled={(props.original.id == undefined) ? false : props.original.id != this.state.editedapiType} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },

            {
                Header: <b>Action</b>,
                accessor: 'action',
                sortable: false,
                width: 100,
                Cell: props => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedapiType) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.original.id == undefined) ? this.saveImageSrc : ((props.original.id != this.state.editedapiType) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == undefined) ? this.addCell(props, e) : (props.original.id == this.state.editedapiType) ?
                                        this.updateCell(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>
                        <button style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.loadData() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original.id
                                    })
                                } />
                        </button>
                    </div>
                ),
            },
        ]
        return (
            <div style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                {/* for reactTable */}

                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="wrapper">
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | API keys </title>
                    {/* IonIcons */}
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    <div className="container-fluid" >
                        <div className="row" style={{ marginTop: '10px' }}>
                            <label style={{ padding: '0px 7.5px' }}>Text-To-Speech API </label>
                            <label class="switch" style={{ marginLeft: '15px' }}>

                                <input type="checkbox"
                                    id={"activate"}
                                    onChange={this.checkHandle}

                                    checked={this.state.isChecked}
                                />
                                <span class="slider round"></span>
                            </label>

                        </div>
                        < ToastContainer className="Toast-at-center" />
                        <div className="row" style={{ display: (this.state.isChecked) ? 'block' : 'none' }}>
                            <div className="col-sm-5">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Basic settings</h6>
                            </div>
                            <div className="col-sm-7" Align="right">
                                <button className="btn action-button"
                                    title="Add"
                                    id="addApiType"
                                    onClick={this.state.disabled ? this.NotifyEmptyFields : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} type="button" title="Refresh" className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img></button>
                            </div>
                            <div className="col-lg-12 ">

                                <div className="card">

                                    <div >
                                        <ReactTable id='reactTable'
                                        Align='center'
                                            data={this.state.data}
                                            columns={this.columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                        {/*Dialog Component For Deletion Confirmation*/}
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Text-To-Speech API Key' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the API key?<br />
                                            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default TtsApiKeys




// WEBPACK FOOTER //
// ./src/ttsUi/TtsApiKeys.js